import * as React from 'react';
import { TroughsDispatcher } from 'src/app/Container';
import { TroughList, TroughDetailModal, ConfigurationHeader } from 'src/app/Partials';

import './ConfigurationTrough.page.scss';
import { match as Match, Route } from 'react-router';
import { ElementNext } from 'src/app/Partials/Configuration/Inputs';
import { NavigationConfigurationKeys, formatMessage, GlobalPrivateState, QueryParemeterPayload } from 'src/api';

import MESSAGES from '../ConfigurationDetail.messages';
import { connect } from 'react-redux';
import { requestAPIActions } from 'loopback-react-request';
import { Dispatch } from 'redux';

export interface ConfigurationTroughPageProps {
  dispatch: Dispatch;
  configuration: GlobalPrivateState['configuration'];
  queryState: GlobalPrivateState['queryState'];
  troughs: GlobalPrivateState['troughs'];
}

export interface ConfigurationTroughPageState {
  didMount: boolean;
}

export class ConfigurationTroughPageComponent extends React.Component<ConfigurationTroughPageProps, ConfigurationTroughPageState> {
  constructor(props: ConfigurationTroughPageProps) {
    super(props);
    this.state = {
      didMount: false,
    };
  } 
  
  componentDidMount() {
    this.setState({didMount: true});
  }

  componentDidUpdate(prevProps: ConfigurationTroughPageProps) {
    const { troughs, configuration } = this.props;

    // Add trough from troughs page... might be able to make faster by submitting initial trough with config somewhere else, like country/project
    const troughsLoaded = troughs.loaded && troughs.result && JSON.stringify(troughs) !== JSON.stringify(prevProps.troughs);
    const configurationLoaded = configuration.loaded && configuration.result;
    const hasTrough = configuration.result && configuration.result.troughId;
    const startingTroughId = localStorage.getItem('startingTrough');

    if (configurationLoaded && !hasTrough && startingTroughId) {
      localStorage.removeItem('startingTrough');

      this.props.dispatch(requestAPIActions.load(
        'configuration',
        { 
          url: `/Configurations/${this.configurationId}`,
          options: {
            method: 'PATCH',
            data: {
              troughId: startingTroughId,
              selectedTrough: {
                qty: 1
              }
            }
          },
        },
        true
      ));
    }
  }

  public render() {
    const { troughs } = this.props;

    return this.state.didMount ? (
      <div className="page-configuration-trough">
        {(!troughs.result || this.filter) &&  (
          <TroughsDispatcher />
        )}
        <div className="main-configuration-right">
          <div className="col-12">
            <ConfigurationHeader 
              icon="trough"
              title={formatMessage(MESSAGES.troughsTitle)}
            />
          </div>
          <div className="col-12 pt-5 pl-5 pr-5 text-center trough-list">
            <div className="trough-list inner pb-4">
              <TroughList />
              {this.configurationId && (
                <Route path={`/configuration/${this.configurationId}/trough/:troughId`} exact={true} render={(props: { match?: Match<{troughId?: string}>}) => {
                  const troughId = props.match && props.match.params && props.match.params.troughId;
                  const backUrl = props.match && troughId && props.match.url.replace(`/${troughId}`, '');
                  
                  return troughId && backUrl ? (
                    <TroughDetailModal troughId={troughId} backUrl={backUrl} />
                  ) : null;
                }} />
              )}
            </div>
          </div>
          <div className="configuration-wrap pl-5 pr-5">
            <div className="col-12 pt-4 text-center">
              <ElementNext id={NavigationConfigurationKeys.selectedTrough} />
            </div>
          </div>
        </div>
      </div>
    ) : null;
  }

  private get filter(): QueryParemeterPayload['filter'] | undefined {
    return this.props.queryState && this.props.queryState.params && this.props.queryState.params.filter;
  }

  private get configurationId(): string | undefined {
    return this.props.configuration.result && this.props.configuration.result.id;
  }
}

export const ConfigurationTroughPage = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  queryState: state.queryState,
  troughs: state.troughs,
}))(ConfigurationTroughPageComponent);

export default ConfigurationTroughPage;